var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCwAiSummary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 17.25L22.5 18.5L19.75 19.75L18.5 22.5L17.25 19.75L14.5 18.5L17.25 17.25L18.5 14.5L19.75 17.25ZM20 4C18.6685 7.27452 18.1638 10.1367 17.5137 12.5L15.6689 11.6602C15.7837 11.2279 15.8994 10.7609 16.0234 10.2549C16.2845 9.18933 16.5722 7.99559 16.9521 6.70215C15.3721 7.07143 13.9639 7.45206 12.7197 7.87305C10.6288 8.58057 9.12977 9.35847 8.09178 10.2666C7.09894 11.1354 6.4681 12.1732 6.17967 13.5684C5.95491 14.6559 5.92824 16.0111 6.1699 17.7256C6.84247 17.6413 7.48239 17.5783 8.07811 17.5205L8.16697 17.5117C9.22148 17.4095 10.0971 17.3246 10.8838 17.1807L11.7461 19.0459C9.71923 19.4986 7.28596 19.4774 4.55174 20L4.44432 19.4863C2.30621 8.82469 7.94387 6.42552 20 4ZM13.9375 13.0625L16 14L13.9375 14.9375L13 17L12.0625 14.9375L9.99998 14L12.0625 13.0625L13 11L13.9375 13.0625Z",
    fill: "url(#paint0_linear_3534_18687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3534_18687",
    x1: 0.68802,
    y1: 14.6103,
    x2: 25.3567,
    y2: 14.7062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D2BDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D2BDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46BBB0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCwAiSummary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CW_AI_Summary.bbfb6f50ec38ffbff234d741d739da2a.svg";